
<template>
  <el-container
    v-if="show_or_not"
    class="content-width"
    style="flex-direction: column"
  >
    <div-unit unitTitle="The progress of your mission">
      <div class="introduce-text">
        <p>
          <b
            >Mission ID: <span style="color: #ff9800">{{ mission_id }}</span></b
          >
        </p>
        <p>
          <b>You mission is running: </b>
        </p>
        <p class="name-wrapper">
          Aligning Structure:
          <span style="color: #ff9800; font-weight: bold">{{
            structure_id
          }}</span>
        </p>
        <p class="name-wrapper">
          Protein Name:
          <span style="color: #ff9800; font-weight: bold">{{
            protein_name
          }}</span>
        </p>

        <p class="name-wrapper">
          Protein Library:
          <span style="color: #ff9800; font-weight: bold">{{ library }}</span>
        </p>
        <el-progress
          :text-inside="true"
          :stroke-width="26"
          :percentage="percentage"
        ></el-progress>
        <p>
          This page reload data in every 2 seconds with no refresh. You DON'T
          need to wait for the mission finished, the program will continue to
          run even if you close this page. If you submit your email address, we
          will notify you by email when the mission is finished.
        </p>
        <p>
          Note: You can save above mission ID or the following hyperlink to
          retrieve your progress and result directly later. Link of this page:
          <a :href="'?id=' + mission_id">{{ url }}</a>
        </p>
        <p>
          The results of this mission will only available on the website for 10
          days from the end of the mission.
        </p>
      </div>
    </div-unit>
  </el-container>
  <el-container v-else class="content-width" style="flex-direction: column">
    <div-unit unitTitle="The progress of your mission">
      <div class="introduce-text">
        <p>Mission being created, please wait a moment ...</p>
        <br />

        <p>
          If the page does not respond for a long time, please check that you
          have the valid mission ID or resubmit the mission.
        </p>
      </div>
    </div-unit>
  </el-container>
</template>

<script>
// import axios from "axios";
import api from "../../api/index";
import DivUnit from "@/components/DivUnit.vue";
// import qs from "qs"
export default {
  data: () => ({
    show_or_not: true,
    mission_id: "",
    percentage: 0,
    library: "waiting  ...",
    protein_name: "waiting  ...",
    structure_id: "waiting  ...",
    url: "",
    timer: null,
  }),
  components: {
    DivUnit,
  },
  methods: {},
  beforeMount() {
    this.mission_id = this.$route.query.id;
    this.url = window.location.origin + "/job?id=" + this.mission_id;
    api.getProgress(this.mission_id).then((res) => {
      this.percentage = res.data.percentage;
      this.library = res.data.library;
      this.protein_name = res.data.protein_name;
      this.structure_id = res.data.structure_id;
    });
  },
  mounted() {
    this.timer = window.setInterval(() => {
      setTimeout(() => {
        api.getProgress(this.mission_id).then((res) => {
          if (res.status == 200) {
            this.show_or_not = res.data.check;
          }
          this.percentage = res.data.percentage;
          this.library = res.data.library;
          this.protein_name = res.data.protein_name;
          this.structure_id = res.data.structure_id;
        });
        if (this.percentage == "100.0") {
          this.$router.push("/result?id=" + this.mission_id);
        }
      }, 0);
    }, 2000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>
<style>
.introduce-text {
  margin-bottom: 30px;
  padding: 16px;
  background: #f1f1f1;
  border-radius: 10px;
  font-size: 20px;
  line-height: 1.8;
}

.el-progress-bar__inner {
  background-color: #66cfff;
}

.el-progress-bar__innerText {
  color: #fff !important;
  font-size: 20px;
}

.el-progress-bar__outer {
  height: 30px !important;
  background-color: #d4eaf4 !important;
}
.name-wrapper {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>